var map = {
	"./Amazon Employement Houston Texas Division website/651791a809278b6e78dbba1f_0.png": 5020,
	"./Arabic sarcasm Detection System/65dec97c7b896b89f77d7914_0.png": 6316,
	"./Developement of Bulleyes company website /6517924409278b6e78dbba33_0.png": 5709,
	"./Developement of Kabylos Resturant website /651792cc09278b6e78dbba4d_0.png": 9728,
	"./Legend Security Services  Los anglos Usa/65dec5f57b896b89f77d790d_0.png": 8042,
	"./Maktabaty/65179dda42f08bf61bc3c2f8_0.png": 9529,
	"./Management of niche inspections of the Sonatrach hydrocarbon pipeline system/651785b63aa70dfbb38ae128_0.png": 1681,
	"./Odoo Erp Internship in ALGERIEN PORT COMMUNITY SYSTEM (SERTPORT)/65179b5edc0c7323cb656690_0.png": 3549,
	"./Pharma App/65ded3db458675d4a6c5b2f2_0.png": 3067
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 152;